import React, { useEffect } from 'react';
import classNames from 'classnames';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/student-info.module.scss';
import { IStudent } from 'src/types/student';
import AdminLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';
import Breadcrumbs from 'src/components/Breadcrumbs';
import { QueryParams } from 'src/types/grid';
import Main from './tabs/Main/MainTab';
import ControlledTabs from 'src/components/common/TabsRoute';
import ProgramBook from './tabs/ProgramBook/ProgramBookTab';
import Documents from './tabs/Documents/DocumentsTab';
import Calendar from './tabs/Calendar';
import Intake from './tabs/Intake';
import Contract from './tabs/Contract';
import { getIntakes } from '../../../../../../store/actions/student-actions';

export interface StateProps {
    files: any;
    student: Partial<IStudent> | null;
    programBooks: any;
    intakes: any;
}

export interface DispatchProps {
    getFiles: (id: string | number) => void;
    getData: (id: string | number) => void;
    getProgramBooks: (param: QueryParams) => void;
    getIntakes: (id: string | number) => void;
}

interface RouteParams {
    id: string;
    tab: string;
}
export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const StudentInfo: React.FunctionComponent<Props> = ({
    student,
    getData,
    getFiles,
    getIntakes,
    files,
    programBooks,
    getProgramBooks,
    match: {
        params: { tab, id },
    },
    history,
}: Props) => {
    useEffect(() => {
        if (id) {
            getFiles(id);
            getIntakes(id);
            getData(id);
            getProgramBooks({
                filters: {
                    'student.id': id,
                },
                itemsPerPage: 2000,
            });
        }
    }, [getData, getFiles, getIntakes, id]);

    if (!student) {
        return null;
    }

    const { firstName, lastName } = student;

    if (!tab) {
        tab = 'student-info';
    }
    const tabs = [
        {
            eventKey: 'student-info',
            title: 'Details',
            isHide: false,
            renderComponent: <Main tab={tab} student={student} programBooks={programBooks} files={files} />,
        },
        {
            eventKey: 'program-book',
            title: 'Program Books',
            isHide: false,
            renderComponent: <ProgramBook tab={tab} student={student} programBooks={programBooks} />,
        },
        {
            eventKey: 'documents',
            title: 'Documents',
            isHide: false,
            renderComponent: <Documents tab={tab} student={student} files={files} />,
        },
        {
            eventKey: 'calendar',
            title: 'Calendar',
            isHide: false,
            renderComponent: <Calendar subId={''} tab={tab} student={student} />,
        },
        {
            eventKey: 'intakes',
            title: 'Intake Forms',
            isHide: false,
            renderComponent: <Intake tab={tab} student={student} />,
        },
        {
            eventKey: 'contracts',
            title: 'Contracts',
            isHide: false,
            renderComponent: <Contract tab={tab} student={student} />,
        },
    ];

    const types: { [key: string]: boolean } = {
        'student-info': true,
        'program-book': true,
        documents: true,
        calendar: true,
        intakes: true,
        contracts: true,
    };

    if (tab && !types[`${tab}`]) {
        tabs.push({
            eventKey: 'student-info',
            title: 'Details',
            isHide: false,
            renderComponent: <Main tab={tab} student={student} programBooks={programBooks} files={files} />,
        });
    }

    const handleSelectTab = (tabPage: string | null) => {
        history.push(Router.generate(routes.STUDENT_DETAIL, { tab: tabPage, id }));
    };

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'STUDENTS', path: routes.STUDENTS_LIST },
                    { name: `${firstName} ${lastName}`, path: '' },
                ]}
            />
            <div className={classNames(styles.detailWrap)}>
                <ControlledTabs tabs={tabs} activeTab={`${tab}`} setTab={handleSelectTab} />
            </div>
        </AdminLayout>
    );
};

export default StudentInfo;
